export default function ConfirmDialog({
  message,
  busy,
  onCancel,
  onConfirm,
  title = "Confirm",
  confirmLabel = "Stop",
  busyLabel = "Stopping...",
}) {
  return (
    <div className="confirm-overlay">
      <div className="confirm-box">
        <h3 className="confirm-title">{title}</h3>
        <hr />
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button className="cancel" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button className="danger" onClick={onConfirm} disabled={busy}>
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
